module.exports = __webpack_public_path__ + "static/media/Euron Greyjoy.55e5fa18.jpg";